'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _categoryAutocomplete = require('./category-autocomplete.component');

var _categoryAutocomplete2 = _interopRequireDefault(_categoryAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.autocomplete.category', []).component('categoryAutocomplete', _categoryAutocomplete2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/category/category-autocomplete.module.js